import { render, staticRenderFns } from "./ChequeMargin.vue?vue&type=template&id=38553ede"
import script from "./ChequeMargin.vue?vue&type=script&lang=js"
export * from "./ChequeMargin.vue?vue&type=script&lang=js"
import style0 from "./ChequeMargin.vue?vue&type=style&index=0&id=38553ede&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports